<p class="text is-level-2 is-marginless" [ngClass]="{ 'has-text-weight-semibold': isBold }">
    <span>{{ dayName }}</span>
    <span [ngClass]="{ 'has-text-weight-medium': !dayOpeningHours }" class="is-pulled-right">
        {{ dayOpeningHours }}
    </span>
</p>
